import { STORAGE_KEYS } from "../../utils/constants/storageKeys";
import { isElectron } from "./index";

let desktopSession = null;
let initialized = false;

const browserSession = () => {
  const persistentToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const sessionToken = sessionStorage.getItem(STORAGE_KEYS.TOKEN);
  const token = persistentToken || sessionToken;
  const role = persistentToken
    ? localStorage.getItem(STORAGE_KEYS.ROLE)
    : sessionStorage.getItem(STORAGE_KEYS.ROLE);
  return token && role
    ? { token, role, persistent: Boolean(persistentToken) }
    : null;
};

const removeLegacyAuth = () => {
  localStorage.removeItem(STORAGE_KEYS.TOKEN);
  localStorage.removeItem(STORAGE_KEYS.ROLE);
  sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
  sessionStorage.removeItem(STORAGE_KEYS.ROLE);
};

export const initializeAuthStorage = async () => {
  if (initialized) return;
  initialized = true;
  if (!isElectron()) return;

  try {
    const nativeSession = await window.electronAPI.auth.getSession();
    if (nativeSession) {
      desktopSession = nativeSession;
      removeLegacyAuth();
      return;
    }

    const legacySession = browserSession();
    if (legacySession) {
      desktopSession = await window.electronAPI.auth.setSession(legacySession);
      removeLegacyAuth();
    }
  } catch (error) {
    initialized = false;
    console.error("Unable to initialize secure authentication storage", error);
  }
};

export const getAuthSession = () => (isElectron() ? desktopSession : browserSession());
export const getAuthToken = () => getAuthSession()?.token ?? null;
export const getAuthRole = () => getAuthSession()?.role ?? null;

export const setAuthSession = async (token, role, persistent = true) => {
  const session = { token, role, persistent: Boolean(persistent) };
  if (isElectron()) {
    desktopSession = await window.electronAPI.auth.setSession(session);
    removeLegacyAuth();
    return desktopSession;
  }

  removeLegacyAuth();
  const storage = persistent ? localStorage : sessionStorage;
  storage.setItem(STORAGE_KEYS.TOKEN, token);
  storage.setItem(STORAGE_KEYS.ROLE, role);
  return session;
};

export const clearAuthSession = async () => {
  desktopSession = null;
  removeLegacyAuth();
  if (isElectron()) await window.electronAPI.auth.clearSession();
};
